<template>
<div>
    <div class="form-2-header-section">
        <div class="form-header-div">
            <div class="div-block-966">
                <a href="#" class="w-inline-block"><img sizes="(max-width: 2083px) 100vw, 2083px" srcset="@/assets/images/_Rx-Pros-Logo-01-p-500.png 500w, @/assets/images/_Rx-Pros-Logo-01-p-800.png 800w, @/assets/images/_Rx-Pros-Logo-01-p-1080.png 1080w, @/assets/images/_Rx-Pros-Logo-01.png 2083w" alt="" src="@/assets/images/_Rx-Pros-Logo-01.png" loading="lazy" class="image-30"></a>

            </div>
        </div>
        <div class="div-block-181">
            <div class="girl-div"></div>
        </div>
    </div>
    <section class="form2-section">
        <div class="form2-main-wrap"></div>
    </section>
    <div class="form-section _2">
        <div class="enroll-div-wrap _2">
        </div>
        <div class="questions-div">
            <div class="question-container _2">
                <div class="question-div-2">
                    <div class="text-block-513 end bold">We&#x27;re Sorry</div>
                    <div class="form-subs end break">Based on the information you provided, you currently do not qualify for our programs.</div>
                    <a href="#" class="button-65 finish w-button">Continue <span class="text-span-172">-&gt;</span></a>
                </div>
            </div>
        </div>
    </div>
    <div style="height: 280px;"></div>
</div>
</template>

<script>
export default {
    name: 'LeadDisqualified',

    data() {
        return {}
    },

    computed: {

    },

    mounted(){
        this.disqualifyUserAndRefund();
    },
    methods: {
        async disqualifyUserAndRefund() {
            
        },
    }
}
</script>

<style scoped>
.back-link {
    cursor: pointer;
    text-decoration: none;
}

.questions-div {
    padding-top: 30px;
    padding-bottom: 50px;
    max-width: 100%;
    padding-left: 20px;
    padding-right: 20px;
}
</style>
